/* eslint-disable sort-keys */
import audienceEnd from '../../assets/sounds/audience-end.mp3'
import audienceStart from '../../assets/sounds/audience-start.mp3'

import messageReceived from '../../assets/sounds/message-received.mp3'
import messageSent from '../../assets/sounds/message-sent.mp3'

import queuePositionChanged from '../../assets/sounds/queue-position-change.mp3'
import queued from '../../assets/sounds/queued.mp3'


export type AudioEvents = 'messageReceived' | 'messageReceivedMinimized' | 'messageSent' | 'messageSentMinimized' | 'audienceStarted' | 'audienceStartedMinimized' | 'queued' | 'queuedMinimized' |
    'audienceEnded' | 'audienceEndedMinimized' | 'audienceTransferred' | 'audienceTransferredMinimized' | 'queuePositionChanged' | 'queuePositionChangedMinimized' | 'promoBubble'

class AudioManager {
    private audienceEndSound = new Audio(audienceEnd)

    private audienceStartSound = new Audio(audienceStart)

    private audienceTransferredSound = new Audio(queued)

    private messageReceivedSound = new Audio(messageReceived)

    private promoBubbleSound = new Audio(messageReceived)

    private messageSentSound = new Audio(messageSent)

    private queuePositionChangedSound = new Audio(queuePositionChanged)

    private queuedSound = new Audio(queued)

    public soundEffects = {
        audienceStarted: this.audienceStartSound,
        audienceStartedMinimized: this.audienceStartSound,
        audienceTransferred: this.audienceTransferredSound,
        audienceTransferredMinimized: this.audienceTransferredSound,
        messageReceived: this.messageReceivedSound,
        messageReceivedMinimized: this.messageReceivedSound,
        messageSent: this.messageSentSound,
        messageSentMinimized: this.messageSentSound,
        queuePositionChanged: this.queuePositionChangedSound,
        queuePositionChangedMinimized: this.queuePositionChangedSound,
        promoBubble: this.promoBubbleSound,
        queued: this.queuedSound,
        queuedMinimized: this.queuedSound,
        audienceEnded: this.audienceEndSound, // to do
        audienceEndedMinimized: this.audienceEndSound, // to do
    }

    private isMuted = false

    public mute() {
        this.isMuted = true
        Object.values(this.soundEffects).forEach((sound) => sound.pause())
    }

    public unmute() {
        this.isMuted = false
    }

    private mapEventToSoundEffect: {[key in AudioEvents]: HTMLAudioElement} = {
        audienceEnded: this.soundEffects.audienceEnded,
        audienceEndedMinimized: this.soundEffects.audienceEndedMinimized,
        messageReceived: this.soundEffects.messageReceived,
        messageReceivedMinimized: this.soundEffects.messageReceivedMinimized,
        messageSent: this.soundEffects.messageSent,
        messageSentMinimized: this.soundEffects.messageSentMinimized,
        audienceStarted: this.soundEffects.audienceStarted,
        audienceStartedMinimized: this.soundEffects.audienceStartedMinimized,
        audienceTransferred: this.soundEffects.audienceTransferred,
        audienceTransferredMinimized: this.soundEffects.audienceTransferredMinimized,
        queued: this.soundEffects.queued,
        queuedMinimized: this.soundEffects.queuedMinimized,
        queuePositionChanged: this.soundEffects.queuePositionChanged,
        queuePositionChangedMinimized: this.soundEffects.queuePositionChangedMinimized,
        promoBubble: this.soundEffects.promoBubble,
    }

    public overrideSoundEffect(event: AudioEvents, soundFile: string | false) {
        if (soundFile === false) {
            this.mapEventToSoundEffect[event] = new Audio()
            return
        }
        const audio = new Audio(soundFile)
        this.mapEventToSoundEffect[event] = audio
    }

    public async playSound(event: AudioEvents) {
        try {
            const soundEffect = this.mapEventToSoundEffect[event]
            if (soundEffect) {
                if (!this.isMuted) {
                    soundEffect.currentTime = 0
                    await soundEffect.play()
                }
            }
        } catch (error) {
            console.error(`Failed to play sound for event: ${event}`, error)
        }
    }
}


export default new AudioManager()
